import { extractTiptapText } from '@shared/dream-components';
import type { JSONContent } from '@tiptap/core';

/**
 * Whether a tiptap document carries no meaningful (non-whitespace) text,
 * matching the editor's "nothing to submit".
 */
export const isTiptapContentEmpty = (content: JSONContent): boolean => extractTiptapText(content) === '';
